import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";

const UsernameAndPasswordSettings = () => {
  const { workerUser } = useOutletContext();
  const [email, setEmail] = useState(workerUser?.email || "");
  const [password, setPassword] = useState("****************");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPasswordStrength, setShowPasswordStrength] = useState(false);

  const getPasswordStrength = (password) => {
    if (password.length < 6) {
      return "Weak";
    } else if (password.length < 10) {
      return "Medium";
    } else {
      return "Strong";
    }
  };

  const passwordStrength = getPasswordStrength(password);

  useEffect(() => {
    if (workerUser) {
      setEmail(workerUser.email || "");
      setPassword("****************");
      setConfirmPassword("");
    }
  }, [workerUser]);

  const handlePasswordFocus = () => {
    if (password === "****************") {
      setPassword("");
    }
  };

  const handleSaveChanges = () => {
    setShowPasswordStrength(true);
  };

  const getPasswordStrengthClass = () => {
    if (passwordStrength === "Weak") {
      return "password-weak";
    } else if (passwordStrength === "Medium") {
      return "password-medium";
    } else if (passwordStrength === "Strong") {
      return "password-strong";
    }
    return "";
  };

  return (
    <div className="usrnmepsswrd-account-settings">
      <h3>Update Logging Details</h3>
      <div className="email-section">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="usrnmepsswrd-password-section">
        <label htmlFor="password">Password</label>
        <input
          type="password"
          id="password"
          value={password}
          onFocus={handlePasswordFocus}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      {showPasswordStrength && password !== "****************" && (
        <div className="usrnmepsswrd-password-strength">
          <p>
            Password Strength ➤&nbsp;
            <span className={getPasswordStrengthClass()}>
              {passwordStrength}
            </span>
          </p>
        </div>
      )}

      <div className="usrnmepsswrd-confirm-password-section">
        <label htmlFor="confirm-password">Confirm Password</label>
        <input
          type="password"
          id="confirm-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </div>

      <button className="usrnmepsswrd-save-button" onClick={handleSaveChanges}>
        Save Changes
      </button>

      <div className="usrnmepsswrd-delete-container">
        <h3>Delete Account</h3>
        <div className="usrnmepsswrd-delete-account">
          <p>
            Permanently delete your account and all personal information from
            One Support Hub. Please ensure there are no outstanding support
            hours.
          </p>
          <p>
            Alternatively, you can mark yourself as unavailable so you aren’t
            visible in any search results. To do this click ‘Edit profile’ at
            the top left of your dashboard and click ‘Availability’ and uncheck
            ‘Show my profile in search results’.
          </p>
        </div>
      </div>

      <h3>Save your documents</h3>
      <div className="usrnmepsswrd-info-section">
        <p>
          You can export your support hours, invoices and business income
          statements from the Billing page.
        </p>
      </div>

      <button className="usrnmepsswrd-delete-button">Delete Account</button>
      {/* <p>
        We’ll ask you to confirm this before your account is permanently
        deleted.
      </p> */}
    </div>
  );
};

export default UsernameAndPasswordSettings;
